<template>
  <div id="editUser">
    <!-- Edit Modal -->
    <b-modal
      v-model="status"
      id="modal-center"
      centered
      title="Edit Service"
      ok-title="Apply"
      @ok="apply"
    >
      <!-- Loading -->
      <div v-if="loading" class="text-center">
        <b-spinner style="width: 3rem; height: 3rem" />
      </div>
      <!-- User Content -->
      <div v-else>
        <!-- name -->
        <b-form-group label="Name" label-for="name">
          <b-form-input v-model="form.name" placeholder="Enter Name" />
        </b-form-group>
        <!-- web title -->
        <b-form-group label="Web Title" label-for="webtitle">
          <b-form-input
            v-model="form.web_title"
            placeholder="Enter Web Title"
          />
        </b-form-group>
        <!-- description -->
        <b-form-group label="Description" label-for="description">
          <b-form-textarea
            v-model="form.description"
            placeholder="Description"
            rows="3"
          />
        </b-form-group>
        <!-- sample -->
        <b-form-group label="Sample" label-for="sample">
          <b-form-textarea
            v-model="form.sample"
            placeholder="Sample"
            rows="3"
          />
        </b-form-group>
        <!-- PHP id -->
        <b-form-group label="PHP id" label-for="php_id">
          <cleave
            v-model.number="form.php_id"
            class="form-control"
            :options="isNumber"
            placeholder="enter number"
          />
        </b-form-group>
        <!-- sources -->
        <b-input-group class="input-group-merge mb-1">
          <v-select
            class="select-list"
            :value="sources.find((s) => s.id == form.source_id)"
            @input="form.source_id = $event.id"
            label="name"
            :options="sources"
            placeholder="Select source"
          />
        </b-input-group>
        <!-- Process time -->
        <b-form-group label="Process time" label-for="process_time">
          <b-form-input
            v-model="form.process_time"
            placeholder="Enter Process Time"
          />
        </b-form-group>
        <!-- curl max -->
        <b-form-group label="Curl max" label-for="curl_max">
          <cleave
            v-model.number="form.curl_max"
            class="form-control"
            :options="isNumber"
            placeholder="enter number"
          />
        </b-form-group>
        <!-- price groups -->
        <div class="group-pricing">
          <b-form-group label="Normal Price" label-for="price">
            <cleave
              v-model.number="form.price"
              class="form-control"
              :options="isNumber"
              placeholder="1,000"
            />
          </b-form-group>
          <b-form-group label="Reseller Price" label-for="price">
            <cleave
              v-model.number="form.reseller_price"
              class="form-control"
              :options="isNumber"
              placeholder="1,000"
            />
          </b-form-group>
        </div>
        <!-- IS Active -->
        <b-form-checkbox
          @input="(v) => (form.is_active = v)"
          :checked="!!form.is_active"
          class="custom-control-primary"
          name="check-button"
          switch
          inline
        >
          Is Active
        </b-form-checkbox>
        <!-- IS Object -->
        <b-form-checkbox
          @input="(v) => (form.is_object = v)"
          :checked="!!form.is_object"
          class="custom-control-primary"
          name="check-button"
          switch
          inline
        >
          Is Object
        </b-form-checkbox>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BFormGroup,
  BFormInput,
  BInputGroup,
  BFormCheckbox,
  BFormTextarea,
} from "bootstrap-vue";
import vSelect from "vue-select";
import Cleave from "vue-cleave-component";
// eslint-disable-next-line import/no-extraneous-dependencies
import "cleave.js/dist/addons/cleave-phone.us";
import Service from "@/services/services.service";
import Source from "@/services/sources.service.js";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  data: () => ({
    loading: false,
    status: false,
    isNumber: {
      numeral: true,
      numeralThousandsGroupStyle: "thousand",
    },
    form: {
      id: null,
      name: null,
      web_title: null,
      price: null,
      reseller_price: null,
      description: null,
      sample: null,
      process_time: null,
      php_id: null,
      source_id: null,
      curl_max: null,
      is_object: false,
      is_active: false,
    },
    sources: [],
  }),
  methods: {
    async apply() {
      this.loading = true;
      try {
        await Service.update(this.form);
        this.$emit("updated");
      } catch (e) {
        const msg =
          e.response.status == 422
            ? Object.values(e.response.data.errors)[0][0]
            : "Something went wrong, please try again";
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Failed to update",
            icon: "XIcon",
            text: msg,
            variant: "danger",
          },
        });
      }
      this.loading = false;
    },
  },
  mounted() {
    Source.fetch().then((data) => (this.sources = data));
    window.editService = async (id) => {
      this.loading = true;
      this.status = true;
      const service = await Service.specific(id);
      Object.keys(this.form).forEach((keyForm) => {
        this.form[keyForm] = service[keyForm];
      });
      this.form.source_id = service.source.id;
      this.loading = false;
    };
  },
  components: {
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BInputGroup,
    vSelect,
    Cleave,
    BFormTextarea,
    // eslint-disable-next-line vue/no-unused-component
    ToastificationContent,
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
.country-list {
  width: 100%;
}
</style>